import useSegmentPage from './useSegmentPage';

export default function SegmentPageTracker() {
    useSegmentPage();
    return null;
}
